import { createContext, ReactNode, useContext } from "react";

export interface PanelPickerOverlayContextValue {
    setOverlay: (content: ReactNode) => void;
}

export const PanelPickerOverlayContext = createContext<PanelPickerOverlayContextValue | null>(null);

export function usePanelPickerOverlay(): PanelPickerOverlayContextValue | null {
    return useContext(PanelPickerOverlayContext);
}
